import Layout from '@/layout/index.vue'
import TrackingEvent from '@/plugins/tracking/event'
import locator from '@/service-locator'
/**
 * constantRoutes
 * a base page that does not have permission requirements
 * all permissions can be accessed
 */
export default [
  {
    path: '/redirect',
    component: Layout,
    hidden: true,
    children: [
      {
        path: '/redirect/:path(.*)',
        component: () => import('@/views/redirect/index.vue'),
      },
    ],
  },
  {
    path: '/login',
    component: () => import('@/views/login/index.vue'),
    hidden: true,
    meta: {
      pageEvent: TrackingEvent.page_view.login_page_viewed,
    },
    beforeEnter: (_, __, next) => {
      locator.tracking.reset()

      next()
    },
  },
  {
    path: '/onboarding',
    component: () => import('@/views/onboarding/index.vue'),
    hidden: true,
  },
  {
    path: '/user-email-verification',
    component: () => import('@/views/authentication/SetPasswordPage.vue'),
    hidden: true,
    props: {
      setPasswordType: 'activated',
    },
  },
  {
    path: '/forgot-password',
    component: () => import('@/views/authentication/ForgotPasswordPage.vue'),
    hidden: true,
  },
  {
    path: '/reset-password',
    component: () => import('@/views/authentication/SetPasswordPage.vue'),
    hidden: true,
    props: {
      setPasswordType: 'reset',
    },
  },
  {
    path: '/404',
    component: () => import('@/views/error-page/404'),
    hidden: true,
  },
  {
    path: '/401',
    component: () => import('@/views/error-page/401'),
    hidden: true,
  },
  {
    path: '/',
    component: Layout,
    hidden: true,
    redirect: '/dashboard/home',
  },
  // // 404 page must be placed at the end !!!
  // { path: '*', redirect: '/404', hidden: true },
]
